/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';

// local imports
import { CampaignService } from 'app/services';
import useDataApi from '../../use-data-api';
import { TableUtils } from 'app/utils';

const useNotCampaignPharmaciesService = (campaignId, queries, isFilteringRef) => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    const notCampaignPharmacyList = await CampaignService.getNotCampaignPharmacyList(
      campaignId,
      queries
    );
    const pharmacies = notCampaignPharmacyList.data.data;

    const out = pharmacies?.map(item => {
      const { ...rest } = item;

      return {
        ...rest
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.notCampaignPharmacyList,
        rows: out
      },
      totalCount: notCampaignPharmacyList?.data?.total_count,
      total: Math.round(notCampaignPharmacyList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useNotCampaignPharmaciesService;
